package com.cs.ejobin.model

data class Extra(
    val id: String,
    val name: String,
    val phone: String,
    val isAvailable: Boolean,
    val skills: List<Skill>,
    val photoUrl: String? = null,
    val description: String? = null,
)